import { GET, POST } from '../annotations';
import { ascii, uint16, uint32 } from '../converters';
import { CallContext, VirtualTap } from '../virtual-tap-server';

export class BundleService {
  constructor(public server: VirtualTap) {
    this.server.bindConfigToRoute({
      default: 0,
      item: (call: CallContext) => {
        const bundle = this.server.configExplorer.getBundleById(
          call.getPathParameter('bundleId')
        );
        if (!bundle.dataLog) {
          bundle.dataLog = {
            period: 0,
          };
        }
        return bundle.dataLog;
      },
      key: 'period',
      path: '/1028/{bundleId}/2',
      converter: uint32,
      get: true,
      put: true,
    });
    this.server.bindConfigToRoute({
      default: '',
      item: (call: CallContext) => {
        const bundle = this.server.configExplorer.getBundleById(
          call.getPathParameter('bundleId')
        );
        return bundle;
      },
      key: 'name',
      path: '/1028/{bundleId}/4',
      converter: ascii,
      get: true,
      put: true,
    });
  }

  @GET({
    path: '/1028/{bundleId}/1',
  })
  public getBundleValues(context: CallContext<void>) {
    return this.server.targetCom.getBundleValues(
      context.pathParameters.bundleId
    );
  }

  @POST({
    path: '/1028/{bundleId}/65535',
    responseType: uint16,
    configModeRequired: true,
    auth: ['admin', 'supervisor'],
  })
  public createBundle(context: CallContext) {
    const id = context.pathParameters.bundleId;
    context.server.configExplorer.createBundle(id);
    return id;
  }
}
